export default __webpack_public_path__ + "static/media/mattermost.3321019f.svg";